import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h5", {
  class: "modal-title",
  id: "exampleModalLabel"
}, "Simulação do agendamento dos Emails", -1)
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "container-fluid" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "table-responsive mb-4" }
const _hoisted_9 = { class: "table table-striped table-sm" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, "ID Email"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, "Email"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Data "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Intervalo "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Data Fixa "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Email Condicional "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Ação executada "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Ação Não executada ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.fechar && $setup.fechar(...args)))
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("table", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.emails, (e) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: e.id
                      }, [
                        _createElementVNode("td", null, _toDisplayString(e.email.id), 1),
                        _createElementVNode("td", null, _toDisplayString(e.email.title), 1),
                        _createElementVNode("td", null, _toDisplayString(e.datesend), 1),
                        _createElementVNode("td", null, _toDisplayString(e.interval), 1),
                        _createElementVNode("td", null, _toDisplayString(e.datesendfixed), 1),
                        _createElementVNode("td", null, _toDisplayString(e.email.condicional== 1 ? "Sim" : "Não"), 1),
                        _createElementVNode("td", null, _toDisplayString(e.email.mailcheck), 1),
                        _createElementVNode("td", null, _toDisplayString(e.email.mailnoaction), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}